import React from 'react';

import { Grid, Typography } from '@material-ui/core';
import { makeStyles /*useTheme*/ } from '@material-ui/core/styles';
// import useMediaQuery from '@material-ui/core/useMediaQuery';

import ep1quoteblockBg from '../..//assets/ep1quoteblockBg.png';

import { useInView } from 'react-intersection-observer';
import { motion } from 'framer-motion';
import { easeInOut } from 'popmotion';

const useStyles = makeStyles((theme) => ({
  wrapper: {
    height: '100vh',
    backgroundImage: `url(${ep1quoteblockBg})`,
    backgroundSize: 'cover',
    marginTop: '10rem',
    backgroundRepeat: 'no-repeat'
  },
  quoteCont: {
    width: '47%',
    [theme.breakpoints.down('sm')]: {
      width: '85%'
    }
  },
  // ------------------------------------------------
  mobileH2: {
    [theme.breakpoints.down('sm')]: {
      ...theme.typography.mobile.h2
    }
  },
  sourceCont: {
    marginTop: '2.8rem'
  },
  source: {
    ...theme.typography.caption,
    color: '#fff'
  }
}));

const QuoteBlock = () => {
  const classes = useStyles();
  //   const theme = useTheme();
  //   const matchesSM = useMediaQuery(theme.breakpoints.down('sm'));
  const { ref, inView } = useInView();

  const renderer = (
    <Grid
      component={motion.div}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1, transition: { duration: 3, ease: easeInOut } }}
      container
      item
      className={classes.quoteCont}
    >
      <Typography
        variant="h2"
        style={{ textTransform: 'uppercase', textAlign: 'center' }}
        className={classes.mobileH2}
      >
        “Many waters cannot quench love, neither can the floods drown it.”{' '}
      </Typography>
    </Grid>
  );

  return (
    <Grid
      ref={ref}
      container
      direction="column"
      justifyContent="center"
      alignItems="center"
      className={classes.wrapper}
    >
      {inView ? renderer : null}
      <Grid item className={classes.sourceCont}>
        <Typography className={classes.source}>Solomon 8:7</Typography>
      </Grid>
    </Grid>
  );
};

export default QuoteBlock;
